<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <h1 class="text-center mt-3">Broadcast Message Configuration</h1>
    <div class="form shadow p-5 mb-5 bg-white rounded">
      <div class="row">
        <div class="col">
          <label for="messageLimit">Maximum sent out per 10 minutes</label
          ><br />
          <small class="note"
            >Note: Maximum value is {{ angleBracketOpening
            }}{{ maxMessagesLimit }}{{ angleBracketEnding }}</small
          >
          <NumberInput
            v-model="messagesLimit"
            input-id="messageLimit"
            :dynamic-class="{
              'input--error': isSubmit && error.errorMessagesLimit,
            }"
          />
          <div v-if="isSubmit && error.errorMessagesLimit" class="text-error">
            {{ error.errorMessagesLimit }}
          </div>
        </div>
        <div class="col"></div>
      </div>

      <div class="d-flex justify-content-end mt-5">
        <button
          class="btn btn-outline-danger ml-10"
          @click="() => $router.go()"
        >
          Cancel
        </button>
        <button class="btn btn-outline-success ml-10" @click="checkValidate">
          Save
        </button>
      </div>
    </div>

    <v-dialog v-model="showDialog" width="500" persistent>
      <div class="content-dialog">
        <h3 v-if="showSuccess">{{ message }}</h3>
        <h5 class="p-5 failureMessage" v-else>{{ message }}</h5>
        <div class="text-center">
          <button
            v-if="showSuccess"
            class="btn-back"
            @click="() => $router.go()"
          >
            กลับสู่หน้าหลัก
          </button>
          <button v-else class="btn-back" @click="showDialog = false">
            ปิด
          </button>
        </div>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import BroadcastMessageConfigService from "services/api/broadcastMessageConfig.service.js";
import NumberInput from "components/NumberInput/NumberInput.vue";

export default {
  components: {NumberInput},
  data() {
    return {
      messagesLimit: 0,
      maxMessagesLimit: 0,
      minMessagesLimit: 0,
      message: "",
      showSuccess: false,
      showDialog: false,
      isLoading: false,
      isSubmit: false,
      angleBracketOpening: "<",
      angleBracketEnding: ">",
      error: {
        errorMessagesLimit: null,
      },
    };
  },
  mounted() {
    this.getBroadcastMessageConfiguration();
  },
  methods: {
    async getBroadcastMessageConfiguration() {
      this.isLoading = true;
      await BroadcastMessageConfigService.getBroadcastMessageConfig()
        .then((res) => {
          const data = res.data;
          this.isLoading = false;
          this.messagesLimit = data.messagesLimit;
          this.maxMessagesLimit = data.maxMessagesLimit;
          this.minMessagesLimit = data.minMessagesLimit;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err.response);
        });
    },
    checkValidate() {
      this.isSubmit = true;
      this.setErrorText(null);
      this.isLoading = true;
      const body = {
        messagesLimit: this.messagesLimit,
      };

      this.setBroadcastMessageConfiguration(body);
    },
    async setBroadcastMessageConfiguration(body) {
      await BroadcastMessageConfigService.setBroadcastMessageConfig(body)
        .then((res) => {
          const data = res.data;
          this.isLoading = false;
          if (data.status === "failure") {
            this.setErrorText(data.message);
          } else {
            this.showDialog = true;
            this.showSuccess = true;
            this.message = "Save broadcast message configuration success";
          }
        })
        .catch((err) => {
          this.isLoading = false;
          console.log("Error: ", err.response);
        });
    },
    setErrorText(message) {
      this.error.errorMessagesLimit = message;
    },
    preventInvalidChars(e) {
      if (['e', 'E', '+', '-'].includes(e.key)) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.note {
  color: red;
}
</style>
